module.exports = __webpack_public_path__ + "img/high-resolution.6c0b5b07.png";